<template>
  <div>
    <div class="modal fade" data-backdrop="static" id="modal-delete-liability">
      <div class="modal-dialog" style="width:700px !important;">
        <div class="modal-content">
          <div class="modal-header"></div>
          <div class="modal-body">
            <span
              for="name"
              class="control-label"
            >Toàn bộ thông tin công nợ, phiếu thu trên hệ thống sẽ bị xóa. Bạn sẽ không thể phục hồi sau khi đồng ý?</span>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-primary btn-sm pull-right mg-left"
              @click="onDeleteLiability"
            >{{$t('common.delete')}}</button>
            <button
              type="button"
              class="btn btn-warning btn-sm pull-left"
              @click="closeModal"
            >{{$t('common.back')}}</button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
    </div>
    <loading :active.sync="isLoading" :can-cancel="false" color="#1E90FF"></loading>
    <lte-core-alert v-for="snackbar in GET_SNACK_BAR" :key="snackbar.id" :item="snackbar"></lte-core-alert>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
//import moment from 'moment'
import LTECoreAlert from "@/components/LTESnackBar.vue";
import Loading from "vue-loading-overlay";
// import utils from '@/lib/utils'

export default {
  name: "ModalDeleteLiability",
  data() {
    return {
       isLoading: false,
    };
  },
  computed: {
    ...mapGetters([
      "GET_SNACK_BAR"
    ])
  },
  methods: {
    /*
     * author : [loitt]
     * function: submit show modal
     * set something info
     */
    submit() {
      $("#modal-delete-liability").modal("show");
    },

    /*
     * author : [loitt]
     * function: close Modal
     */
    closeModal: function() {
      $("#modal-delete-liability").modal("hide");
      this.disabledCheckin = true;
    },

    /*
     * author : [loitt]
     * function: onDeleteLiability
     *       process delete liability
     *       callBackActionDeleteLiability
     */
    onDeleteLiability: async function() {
      await this.removeLiability();

      $("#modal-delete-liability").modal("hide");
      this.$emit("callBackActionDeleteLiability");
    },

    /*
     * author : [loitt]
     * function: removeLiability
     *       call API delete liability
     */
    removeLiability() {
      this.isLoading = true
      this.DELETE_LIABILITY_ALL()
        .then(
          function() {
            this.isLoading = false
            this.SUCCESS_TOAST();
          }.bind(this)
        )
        .catch(
          function(error) {
            this.isLoading = false
            this.ERROR_TOAST();
          }.bind(this)
        );
    },

    ...mapActions([
      "SUCCESS_TOAST",
      "ON_SHOW_TOAST",
      "ERROR_TOAST",
      "DELETE_LIABILITY_ALL"
    ])
  },
  mounted() {},
  components: {
    "lte-core-alert": LTECoreAlert,
    "loading": Loading,
  }
};
</script>
<style lang="scss" scoped>
.mg-left {
  margin-left: 5px;
}
.hide-scroll-bar::-webkit-scrollbar {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/views/Report/ModalDeleteLiability.vue